import styled from 'styled-components';

const VoteThreadButton = styled.button`
  background-color: initial;
  border: 0;
  color: var(--on-background);
  cursor: pointer;
`;

export default VoteThreadButton;
